import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../Apiurs/Apiurls";
import Navbar from "../../../Shared/ManagerNavbar/Navbar";
import { AuthContext } from "../../../AuthContext/Authcontext";
import CustomQuillEditor from "../../Associate/Mailhistory/CustomQullier";
import "../../Associate/Mailhistory/Email.css";

const EmailHistory = () => {
  const { leadid } = useParams();
  const { userEmail } = useContext(AuthContext);
  const location = useLocation();
  const { email } = location.state || {};

  const [text, setText] = useState("");
  const [subject, setSubject] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [receiverEmails, setReceiverEmails] = useState(email || "");
  const [groupedEmailHistory, setGroupedEmailHistory] = useState([]);
  const [ccEmails, setCcEmails] = useState("");
  const [bccEmails, setBccEmails] = useState("");
  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const chatEndRef = useRef(null);

  // 🔹 Fetch email history
  useEffect(() => {
    if (leadid) {
      console.log("📩 Fetching email history for Lead ID:", leadid);
      fetchEmailHistory(leadid);
    } else {
      console.warn("⚠️ leadid not found in URL params!");
    }
  }, [leadid]);

const fetchEmailHistory = async (leadid) => {
  try {
    const url = `${baseURL}/api/email-history/${leadid}`;
    console.log("🔹 API URL:", url);

    const response = await axios.get(url);
    console.log("✅ Full Response:", response);

    if (response.data && response.data.success) {
      console.log("📦 Email Data:", response.data.data);

      // ✅ Safe parsing helper
      const safeParse = (value) => {
        if (!value) return [];
        try {
          const parsed = JSON.parse(value);
          return Array.isArray(parsed) ? parsed : [parsed];
        } catch {
          return [value];
        }
      };

      const emails = response.data.data.map((email) => ({
        ...email,
        receiver_email: safeParse(email.receiver_email),
        cc_emails: safeParse(email.cc_emails),
        bcc_emails: safeParse(email.bcc_emails),
      }));

      // 🔹 Sort by date
      const sortedEmails = emails.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );

      // 🔹 Group sent emails
      const groupedEmails = [];
      let currentGroup = null;

      sortedEmails.forEach((email) => {
        if (email.type === "sent") {
          if (
            currentGroup &&
            Math.abs(new Date(email.created_at) - new Date(currentGroup.created_at)) < 60000 &&
            email.subject === currentGroup.subject &&
            email.text === currentGroup.text
          ) {
            currentGroup.recipients.push(...email.receiver_email);
          } else {
            if (currentGroup) groupedEmails.push(currentGroup);
            currentGroup = {
              ...email,
              recipients: [...email.receiver_email],
              isGrouped: true,
              id: email.id,
            };
          }
        } else {
          if (currentGroup) {
            groupedEmails.push(currentGroup);
            currentGroup = null;
          }
          groupedEmails.push({ ...email, isGrouped: false });
        }
      });

      if (currentGroup) groupedEmails.push(currentGroup);

      console.log("🧩 Grouped Emails:", groupedEmails);
      setGroupedEmailHistory(groupedEmails);
    } else {
      console.warn("⚠️ Empty data from API");
    }
  } catch (error) {
    console.error("❌ Error fetching email history:", error);
  }
};


  // 🔹 File upload
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      alert("File size must be below 2MB.");
      return;
    }
    setSelectedFile(file);
  };

const handleSendEmail = async () => {
  if (!text && !selectedFile) {
    alert("Please enter a message or upload a file.");
    return;
  }

  const receivers = receiverEmails.split(",").map((e) => e.trim()).filter(Boolean);
  if (receivers.length === 0) {
    alert("Please enter at least one recipient email.");
    return;
  }

  const cc = showCC ? ccEmails.split(",").map((e) => e.trim()).filter(Boolean) : [];
  const bcc = showBCC ? bccEmails.split(",").map((e) => e.trim()).filter(Boolean) : [];

  const formData = new FormData();
  formData.append("leadid", leadid);
  formData.append("sender_email", userEmail || "landnestiiiqbets@gmail.com");
  formData.append("text", text);
  formData.append("subject", subject || "New Message");
  formData.append("type", "sent");
  formData.append("is_plain_text", "true");
  formData.append("receiver_email", JSON.stringify(receivers));
  if (showCC) formData.append("cc_emails", JSON.stringify(cc));
  if (showBCC) formData.append("bcc_emails", JSON.stringify(bcc));
  if (selectedFile) formData.append("file", selectedFile);

  try {
    setLoading(true);
    console.log("📤 Sending email...");
    
    const res = await axios.post(`${baseURL}/api/send-email`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 30000, // Add timeout to prevent hanging
    });

    console.log("✅ Email sent response:", res.data);

    // ✅ FIXED: Better response checking
    if (res.data && (res.data.success === true || res.status === 200)) {
      alert("✅ Email sent successfully!");
      
      // Reset form
      setText("");
      setSubject("");
      setSelectedFile(null);
      setCcEmails("");
      setBccEmails("");
      setShowCC(false);
      setShowBCC(false);

      // Immediately refetch updated history
      await fetchEmailHistory(leadid);
    } else {
      console.warn("Unexpected response:", res.data);
      alert("⚠️ Email sent but with unexpected response. Please check if it was delivered.");
      
      // Still refetch history in case it was saved
      await fetchEmailHistory(leadid);
    }
  } catch (error) {
    console.error("❌ Error sending email:", error);
    
    if (error.code === 'ECONNABORTED') {
      alert("⏰ Request timeout. Email may still have been sent. Refreshing history...");
    } else {
      alert("Failed to send email. Please try again.");
    }
    
    // Try to refetch history anyway in case the email was actually sent
    try {
      await fetchEmailHistory(leadid);
    } catch (fetchError) {
      console.error("Failed to refetch history:", fetchError);
    }
  } finally {
    // ✅ FIXED: Always reset loading state
    setLoading(false);
  }
};
  // 🔹 Clean quoted text
  const cleanEmailText = (text) => {
    if (!text) return "";
    const cleanedText = text.split(/\n?On\s.+\s(?:at|wrote:)/i)[0];
    return cleanedText.replace(/--\sThis email has been checked for viruses.*/is, "").trim();
  };

  return (
    <div className="emailhistory-container">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`chat-content ${collapsed ? "collapsed" : ""}`}>
        <h2 className="emailhistory-header">
          Email History with <span>{email}</span>
        </h2>

        {/* 🔹 Email History List */}
        <div className="emailhistory-history-list">
          {groupedEmailHistory.length === 0 ? (
            <p className="text-center">No emails found.</p>
          ) : (
            groupedEmailHistory.map((emailItem) => (
              <div
                key={`${emailItem.id}_${emailItem.created_at}`}
                className="emailhistory-history-item"
                style={{
                  display: "flex",
                  justifyContent:
                    emailItem.type === "sent" ? "flex-end" : "flex-start",
                }}
              >
                <div
                  className={`opp-message-bubble ${
                    emailItem.type === "sent" ? "sent" : "received"
                  }`}
                >
                  {emailItem.isGrouped && (
                    <div className="recipients">
                      <strong>Recipients:</strong>{" "}
                      <b>{emailItem.recipients.join(", ")}</b>
                    </div>
                  )}
                  <p className="emailhistory-subject">
                    <strong>Subject:</strong> {emailItem.subject || "No Subject"}
                  </p>
                  {!emailItem.isGrouped && emailItem.type === "sent" && (
                    <p className="emailhistory-receivers">
                      <strong>To:</strong> {emailItem.receiver_email.join(", ")}
                    </p>
                  )}
                  {!emailItem.isGrouped && emailItem.type === "received" && (
                    <p className="emailhistory-receivers">
                      <strong>From:</strong> {emailItem.sender_email}
                    </p>
                  )}
                  <div
                    className="emailhistory-content"
                    dangerouslySetInnerHTML={{
                      __html: cleanEmailText(emailItem.text),
                    }}
                  />
                  {emailItem.file_path && (
                    <a
                      href={`${baseURL}${emailItem.file_path}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="attachment-link"
                    >
                      📎 View Attachment
                    </a>
                  )}
                  <div
                    className="timestamp"
                    style={{ fontSize: "0.75rem", color: "#666" }}
                  >
                    {new Date(emailItem.created_at).toLocaleString()}
                  </div>
                </div>
              </div>
            ))
          )}
          <div ref={chatEndRef} />
        </div>

        {/* 🔹 Send Email Form */}
        <div className="emailhistory-form">
          <h3>Send Email</h3>

          <div className="emailhistory-form-group">
            <label>To:</label>
            <textarea
              placeholder="Enter recipient emails (comma separated)"
              value={receiverEmails}
              onChange={(e) => setReceiverEmails(e.target.value)}
              className="emailhistory-input-receivers"
            />
          </div>

          <div className="emailhistorycc-bcc-toggle">
            <label className="emailhistory-toggle-label">
              <input
                type="checkbox"
                checked={showCC}
                onChange={() => setShowCC(!showCC)}
              />{" "}
              Add CC
            </label>
            <label className="emailhistory-toggle-label">
              <input
                type="checkbox"
                checked={showBCC}
                onChange={() => setShowBCC(!showBCC)}
              />{" "}
              Add BCC
            </label>
          </div>

          {showCC && (
            <div className="emailhistory-form-group">
              <label>CC:</label>
              <textarea
                placeholder="Enter CC emails (comma separated)"
                value={ccEmails}
                onChange={(e) => setCcEmails(e.target.value)}
                className="emailhistory-input-receivers"
              />
            </div>
          )}

          {showBCC && (
            <div className="emailhistory-form-group">
              <label>BCC:</label>
              <textarea
                placeholder="Enter BCC emails (comma separated)"
                value={bccEmails}
                onChange={(e) => setBccEmails(e.target.value)}
                className="emailhistory-input-receivers"
              />
            </div>
          )}

          <div className="emailhistory-form-group">
            <label>Subject:</label>
            <input
              type="text"
              placeholder="Enter Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="emailhistory-input-subject"
            />
          </div>

          <div className="email-form-group">
                <label className="email-form-label">Message:</label>
                <CustomQuillEditor
                  value={text}
                  onChange={setText}
                  className="email-rich-text-editor"
                  placeholder="Enter your message here..."
                />
              </div>

          <div className="emailhistory-form-group">
            <label>Attachment:</label>
            <input
              type="file"
              onChange={handleFileChange}
              className="emailhistory-file-input mb-2"
            />
          </div>

          <button
            onClick={handleSendEmail}
            disabled={loading}
            className="emailhistory-send-button"
          >
            {loading ? "Sending..." : "Send Email"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailHistory;
